<template>
<div class="home-container-wrap">
  <div class="home-container" :style="{ backgroundImage: 'url('+backgroudPicture+')', backgroundRepeat: 'no-repeat', backgroundSize: 'cover',}">
      <img class="decoration3" src="../assets/images/decoration4.png" alt="">
      <div class="top-con">
        <img v-if="bannerPicture" :src="bannerPicture" alt="">
      </div>
      <div class="content" :class="{mtc: !bannerPicture}">
        <div class="input-wrap">
          <img class="decoration2" src="../assets/images/decoration2.png" alt="">
          <img class="decoration1" src="../assets/images/decoration3.png" alt="">
          <span v-if="notWap" class="tis">当前用户</span>
          <!-- <input type="number" placeholder="" v-model="mobile" @input="mobileInput" @focus="mobileFocus" @blur="mobileBlur"> -->
          <input v-if="notWap" placeholder="" v-model="mobile" @input="mobileInput" disabled="disabled" >
          <div class="close_img" v-if="showClose" @click="emptyMobile">
            <img src="../assets/images/close.png" alt="">
          </div>
        </div>
        <button @click="goDraw">立即抽奖</button>
        <div class="rule-wrap">
          <div class="title-wrap">
            <div class="title_bg"></div>
          </div>
          <div class="text-wrap">
            <p v-html="rule"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Locator from '@/utils/location';
import api from '@/api/activity-mp';
import { agent } from '@/utils';

export default {
  name: 'Home',
  data() {
    return {
      mobile: '',
      token: '',
      lotteryId: '',
      nickName: '',
      location: '',
      rule: '',
      // bannerPicture: require('../assets/images/title.png'),
      bannerPicture: '',
      backgroudPicture: '',
      showClose: false,
      notWap: true,
      activityName: '',
    };
  },
  created() {
    const locator = new Locator();
    locator.getLocation('mp').then((res) => {
      console.log('获取地址res', res);
      this.location = res;
    });
  },
  mounted() {
    const q = this.$route.query;
    this.mobile = q.mobile;
    this.lotteryId = q.lotteryId;
    this.token = q.token;
    this.nickName = q.nickName ? decodeURIComponent(q.nickName) : '';
    this.notWap = true;
    if (agent === 'native') {
      window.getNickName((res) => {
        this.mobile = res.nickName;
      });
      window.getToken((res) => {
        if (res.token) {
          this.token = res.token;
          this.getActivityH5Conf();
        } else {
          this.$toast('请登录');
          window.serviceError('14101');
          window.closeWebView();
        }
      });
    } else {
      if (agent === 'wap') {
        this.notWap = false;
      }
      this.getActivityH5Conf();
    }
  },
  methods: {
    mobileFocus() {
      if (this.mobile) {
        this.showClose = true;
      }
    },
    mobileBlur() {
      setTimeout(() => {
        this.showClose = false;
      });
    },
    emptyMobile() {
      this.mobile = '';
    },
    mobileInput() {
      if (this.mobile.length >= 11) {
        this.mobile = this.mobile.slice(0, 11);
      }
    },
    getActivityH5Conf() {
      const params = {
        activityCode: this.lotteryId,
      };
      console.log(api);
      api.getActivityH5Conf(params).then((res) => {
        document.title = res.data.data.activityName;
        this.activityName = res.data.data.activityName;
        this.bannerPicture = res.data.data.bannerPicture;
        this.backgroudPicture = res.data.data.backgroudPicture;
        this.rule = res.data.data.ruleDescription;
        this.$store.commit('setBackgroud', res.data.data.backgroudPicture);
        this.$store.commit('setRule', res.data.data.ruleDescription);
        this.$store.commit('setTitle', res.data.data.activityName);
        this.$store.commit('setAdnum', res.data.data.adNum);
        const activityInfo = {
          adNum: res.data.data.adNum,
          token: this.token,
          lotteryId: this.lotteryId,
        };
        console.log('token----:', this.token);
        localStorage.setItem('activityInfo', JSON.stringify(activityInfo));
        // 扫码埋点
        const activitysource = this.$route.query.activitysource;
        if (activitysource) {
          window.gio('track', 'btl_activitybuttonclick', {
            activitysource_pvar: '扫码小程序二维码',
            activityname_var: res.data.data.activityName,
            pagename_var: '抽奖首页',
          });
        }
      });
    },
    goDraw() {
      // H5跳转下载页
      if (agent === 'wap') {
        window.location.href = `${process.env.VUE_APP_MGT_URL}/MG/general_utility/download/index.html`;
      } else {
        window.gio('track', 'activitypage_buttonclick', {
          pagename_var: '抽奖首页',
          pitname_var: '立即抽奖',
          activityname_var: this.activityName,
        });
        this.$store.commit('setToken', this.token);
        this.$store.commit('setMobile', this.mobile);
        this.$router.push({ path: 'draw' });
      }
    },
  },
};
</script>
<style lang='stylus'>
.mtc{
  margin 40% 0 40% !important
}
.home-container-wrap{
  width 100vw
  height 100%
  background: url('../assets/images/home_bg.png') no-repeat top center;
  background-size: cover;
}
.home-container{
  overflow-x:hidden
  background: no-repeat center top
  background-size: 100%
  position: relative;
  .decoration3{
    width 30px
    height 39px
    position absolute
    top: 10px
    right 20px
  }
  .top-con{
    text-align center
    // padding-top: 60px
    img{
      width 375px
      height 375px
    }
  }
  .content{
    width 100%
    margin-top 20px
    position: relative
    .input-wrap{
      padding 0 38px
      text-align center
      position relative
      .decoration1{
        width 22px
        height 32px
        position absolute
        top: 5px
        right 55px
      }
      .decoration2{
        width 30px
        height 39px
        position absolute
        top: -35px
        left 30px
      }
      .tis{
        padding 0 0 5px 10px
        color #fff
        text-align left
        width 100%
        display flex
      }
      .line{
        height 1px
        margin-top: 14px;
      }
      .close_img{
        position: absolute;
        bottom: 0;
        right: 12vw;
        width: 40px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width 16px
          height 16px
        }
      }

    }
    input{
      width 276px
      height 48px
      padding-left 20px
      font-size: 20px;
      background-color transparent
      border-radius 3px
      // text-indent: 6px;
      text-align left
      background: url('../assets/images/input_bg.png') no-repeat top center !important

    }
    button{
      display block
      width 242px
      height 56px
      margin 30px auto
      color #fff
      font-size 16px
      font-weight: bold
    }
    .rule-wrap{
      width 339px
      margin 39px auto
      border-radius: 8px;
      padding 15px
      box-sizing border-box
      .text-wrap{
        border-radius: 6px;
        padding 16px
        p{
          font-size: 12px;
          color: #FFFFFF;
          line-height: 22px;
        }
      }
    }
  }
}
.title-wrap{
  display flex
  align-items: center;
  justify-content: center;
  margin-bottom 25px
  i{
    width 21px
    height 16px
  }
  .left{
    background url('../assets/images/lefti.png') no-repeat center
    background-size contain
  }
  h3{
    font-family: PingFangSC-Medium;
    font-size: 16px;
    padding 0 16px
  }
  .right{
    background url('../assets/images/righti.png') no-repeat center
    background-size contain
  }
}
</style>
